import Vue from "vue";
import Vuex from "vuex";
import VueTour from "vue-tour";

import * as actions from "./actions";
import * as mutations from "./mutations";
import {
    params
} from "./params";

require('vue-tour/dist/vue-tour.css');

Vue.use(Vuex);
Vue.use(VueTour);

const store = new Vuex.Store({
    modules: {
        params
    },
    strict: true,
    actions,
    mutations,
    state: {
        prod: true,
        auth: null,
        loading: false,
        pdfloading: false,
        csvloading: false,
        fileuploading: false,
        projects: null,
        project: null,
        windows: null,
        window: null,
        bom: null,
        handles: null,
        motors: null,
        profiles: null,
        invisitopprofiles: null,
        users: null,
        windowCreateResponse: null,
        translations: null,
        versions: null,
        version: null,
        latestversion: 0,
        errorlist: null,
        invalidfile: false,
        language: null,
        sharedusers: null,
        sharedprojects: null,
        genericDownloads: null,
        windowsortoptions: 'newold',
        projectsortoptions: 'newold',
        countries: null,
        languages: null,
        syscos: null
    },
    getters: {
        getAddress(state) {
            var url = ""
            if (state.prod == true) {
                url = 'https://classic-api.chronologiconline.com/api/';
            } else {
                url = 'https://classic-dev-api.chronologiconline.com/api/';
                //url = 'https://localhost:44393/api/'
            }
            return url;
        },
        isAuthenticated(state) {
            return state.auth !== null && state.auth.access_token !== null;
        },
        getProjectById: (state) => (id) => {
            var prj = state.projects.find(project => project.id == id);
            if (prj == null)
                return null;
            else
                return prj;
        },
        getWindowById: (state) => (id) => {
            var win = state.windows.find(window => window.id == id);
            if (win == null)
                return null;
            else
                return win;
        },
        getCurrentProject: (state) => {
            return state.project;
        },
        getProjects: (state) => {
            return state.projects;
        },
        getWindows: (state) => {
            return state.windows;
        },
        getCountries: (state) => {
            return state.countries
        },
        getLanguages: (state) => {
            return state.languages
        },
        getSysCos: (state) => {
            return state.syscos
        },
        getHandleByAN: (state) => (anr) => {
            return state.handles.find(handle => handle.anr == anr)
        },
        getTranslationByTerm: (state) => (term) => {
            if (term != null && state.translations != null) {
                var retval = state.translations.find(caption => caption.term == term);
            } else {
                var retval = '';
            }
            return retval;
        },
        getTypes: (state) => {
            if (state.auth != null)
                return state.params.type.filter(f => f.sysco == 0 || f.sysco == state.auth.systemCompany);
            else
                return null;
        },
        getProfiles: (state) => {
            if (state.auth != null)
                return state.profiles;
            else
                return null;
        },
        getInvisitopProfilesForWindow: (state) => (hinge, chrono) => {
            return state.invisitopprofiles.filter(p => p.hin == hinge && p.chr == chrono);
        },
        getAuth: (state) => {
            if (state.auth != null)
                return state.auth;
            else
                return null;
        },
        getUserlist: (state) => {
            var s = state.users;
            return s;
        },
        getLanguage: (state) => {
            if (state.language != null) {
                if (state.language == "Nederlands")
                    return "NED"
                else
                    return "ENG"
            }
        },
        getUserById: (state) => (id) => {
            var usr = state.users.find(user => user.userId == id);
            if (usr == null)
                return null;
            else
                return usr;
        },
        getshareduser: (state) => (id) => {
            var usr = state.sharedusers.find(user => user.userId == id);
            if (usr == null)
                return null;
            else
                return usr;
        },
        getshareduserinfo: (state) => (id, ro) => {
            var usr = state.sharedusers.find(user => (user.userId == id));
            if (usr == null)
                return null;
            else
                return usr;
        },
        getVNList: (state) => {
            var vn = 0;
            var vnlist = [];
            for (var i = 0, len = state.versions.length; i < len; i++) {
                if (state.versions[i].vn != vn) {
                    vnlist.push(state.versions[i].vn);
                    vn = state.versions[i].vn;
                }
            }
            return vnlist;
        },
        getVersion: (state) => {
            return state.version;
        },
        getWindowSortOptions: (state) => {
            return state.windowsortoptions;
        },
        getProjectSortOptions: (state) => {
            return state.projectsortoptions;
        },
        getprojro: (state) => (id) => {
            var proj = state.sharedprojects.find(pr => (pr.projectId == id && pr.ownerId == state.auth.userId));
            if (proj != null) return 0
            if (proj == null) proj = state.sharedprojects.find(pr => (pr.projectId == id && pr.userId == state.auth.userId));
            if (proj == null) return 0
            return proj.readonly
        },

        getLatestVN: (state) => {
            var vn = 0;
            if (state.versions != null) {
                for (var i = 0, len = state.versions.length; i < len; i++) {
                    if (state.versions[i].vn > vn) {
                        vn = state.versions[i].vn;
                    }
                }
                return vn;
            } else
                return null;
        },
        getGenericDownloads: (state) => {
            return state.genericDownloads;
        },
        getMotors: (state) => {
            return state.motors;
        }
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/ClientApp/store/index.js